module.exports = __webpack_public_path__ + "img/voice_202307_02.ed0c65ba.jpg";